export default function getEcheanceId(idReglement, lettrage) {
  if (idReglement === lettrage.mouvementClient1Id) {
    return lettrage.mouvementClient2Id;
  }
  return lettrage.mouvementClient1Id;
}
